import {
    Chart as ChartJS,
    CategoryScale,
    LinearScale,
    BarElement,
    Title,
    Tooltip,
    Legend,
} from 'chart.js'
import { Bar } from 'react-chartjs-2'
import { useTranslation } from 'react-i18next'

// Register chart.js components
ChartJS.register(CategoryScale, LinearScale, BarElement, Title, Tooltip, Legend)

const DonationsChart = ({ data, isMostNeeded = false }) => {
    const monthlyIncome = isMostNeeded
        ? data?.data?.monthly_amounts?.map(value => parseFloat(value) || 0)
        : data?.data?.monthly_income?.map(value => parseFloat(value) || 0) || []
    const labels = data?.data?.labels
    const { t } = useTranslation()

    const chartData = {
        labels,
        datasets: [
            {
                label: t('dashboard.monthly_income'),
                data: monthlyIncome,
                backgroundColor: isMostNeeded
                    ? 'rgba(245, 158, 11, 0.7)'
                    : 'rgba(59, 130, 246, 0.7)',
                borderRadius: 6,
            },
        ],
    }

    const chartOptions = {
        responsive: true,
        plugins: {
            legend: {
                position: 'top',
            },
            title: {
                display: true,
                text: `${isMostNeeded ? t('dashboard.where_most_needed_income') : t('dashboard.donation_income')} - ${data?.data?.year}`,
            },
        },
        scales: {
            y: {
                beginAtZero: true,
                ticks: {
                    callback: value => `${value}`,
                },
            },
        },
    }

    return <Bar data={chartData} options={chartOptions} />
}

export default DonationsChart
